//@import pages
import PublicScreen from 'app_components/screens/landing/public'
import ShopScreen from 'app_components/screens/landing/shop'
import CourseScreen from 'app_components/screens/landing/course'
import AllNewsScreen from 'app_components/screens/landing/allnews'
import AllEventsScreen from 'app_components/screens/landing/allevents'
import NewsItemScreen from 'app_components/screens/landing/newsitem'
import EventItemScreen from 'app_components/screens/landing/eventitem'
import ResearchItemScreen from 'app_components/screens/landing/researchitem'
import CapsuleItemScreen from 'app_components/screens/landing/capsuleitem'
import WebinarItemScreen from 'app_components/screens/landing/webinaritem'
import BlogItemScreen from 'app_components/screens/landing/blogitem'
import MoocsScreen from 'app_components/screens/landing/moocs'
import CapsulasScreen from 'app_components/screens/landing/capsulas'
import WebinarsScreen from 'app_components/screens/landing/webinars'
import ArticulosScreen from 'app_components/screens/landing/articulos'
import DescmoocsScreen from 'app_components/screens/landing/descmoocs'
import BlogsScreen from 'app_components/screens/landing/blogs'
import MoocScreen from 'app_components/screens/landing/mooc'
import TeachersScreen from 'app_components/screens/landing/teachers/index';
import BusinessScreen from 'app_components/screens/landing/business/index';
import OfficialsScreen from 'app_components/screens/landing/officials/index';
import IcontecResourcesScreen from 'app_components/screens/landing/icontecResources/index';
import PodcastsScreen from 'app_components/screens/landing/podcasts'
import PodcastItemScreen from 'app_components/screens/landing/podcastitem'
import StudentsScreen from 'app_components/screens/landing/students/index';
import ForumsScreen from 'app_components/screens/landing/forums/index';
import ForumScreen from 'app_components/screens/landing/forum';
import AlliancesScreen from 'app_components/screens/landing/alliances/AlliancesScreen'
import TutorialsPage from 'app_components/screens/landing/tutorials/TutorialsPage'
import JournalsScreen from 'app_components/screens/landing/journals/journalsScreen'
import VerifyEmail from 'app_components/screens/VerifyEmail/VerifyEmail'
import TransactionStatusScreen from 'app_components/screens/TransactionStatusScreen/TransactionStatusScreen'
import AcademicFilterScreen from 'app_components/screens/landing/AcademicFilterScreen/AcademicFilterScreen'
import { CourseScreenSlug } from 'app_types/campus/academic/courseTypes'
import ShoppingCart from 'app_components/screens/ShoppingCart/ShoppingCart'
//@end

export const routes = [
  {
    path: '/',
    exact: true,
    component: PublicScreen,
  },
  {
    path: '/cursos',
    exact: true,
    component: ShopScreen,
  },
  {
    path: '/curso/:slug',
    exact: true,
    component: CourseScreen,
    customs: {
      slug_type: CourseScreenSlug.COURSE_SLUG
    }
  },
  {
    path: '/curso/:slug/novedad',
    exact: true,
    component: CourseScreen,
    customs: {
      slug_type: CourseScreenSlug.PROGRAM
    }
  },
  {
    path: '/sobremoocs',
    exact: true,
    component: DescmoocsScreen,
  },
  {
    path: '/moocs',
    exact: true,
    component: MoocsScreen,
  },
  {
    path: '/mooc',
    exact: true,
    component: MoocScreen,
  },
  {
    path: '/capsulas',
    exact: true,
    component: CapsulasScreen,
  },
  {
    path: '/capsula/:slug',
    exact: true,
    component: CapsuleItemScreen,
  },
  {
    path: '/podcasts',
    exact: true,
    component: PodcastsScreen,
  },
  {
    path: '/podcast/:slug',
    exact: true,
    component: PodcastItemScreen,
  },
  {
    path: '/webinars',
    exact: true,
    component: WebinarsScreen,
  },
  {
    path: '/webinar/:slug',
    exact: true,
    component: WebinarItemScreen,
  },
  {
    path: '/articulos',
    exact: true,
    component: ArticulosScreen,
  },
  {
    path: '/journals',
    exact: true,
    component: JournalsScreen,
  },
  {
    path: '/articulo/:slug',
    exact: true,
    component: ResearchItemScreen,
  },
  {
    path: '/noticias',
    exact: true,
    component: AllNewsScreen,
  },
  {
    path: '/noticia/:slug',
    exact: true,
    component: NewsItemScreen,
  },
  {
    path: '/eventos',
    exact: true,
    component: AllEventsScreen,
  },
  {
    path: '/evento/:slug',
    exact: true,
    component: EventItemScreen,
  },
  {
    path: '/blogs',
    exact: true,
    component: BlogsScreen,
  },
  {
    path: '/forum/:id',
    exact: true,
    component: ForumScreen,
  },
  {
    path: '/forums',
    exact: true,
    component: ForumsScreen,
  },
  {
    path: '/blog/:slug',
    exact: true,
    component: BlogItemScreen,
  },
  {
    path: '/teachers',
    exact: true,
    component: TeachersScreen,
  },
  {
    path: '/business',
    exact: true,
    component: BusinessScreen,
  },
  {
    path: '/officials',
    exact: true,
    component: OfficialsScreen,
  },
  {
    path: '/students',
    exact: true,
    component: StudentsScreen,
  },
  {
    path: '/icontec-resources',
    exact: true,
    component: IcontecResourcesScreen
  },
  {
    path: '/alliances',
    exact: true,
    component: AlliancesScreen,
  },
  {
    path: '/tutorials',
    exact: true,
    component: TutorialsPage,
  },
  {
    path: '/confirm-email',
    exact: true,
    component: VerifyEmail,
  },
  {
    path: '/payment-status/:transactionId',
    exact: true,
    component: TransactionStatusScreen,
  },
  {
    path: '/academic-filter',
    exact: true,
    component: AcademicFilterScreen,
  },
  {
    path: '/shopping-cart',
    exact: true,
    component: ShoppingCart
  }
]
